import { useEffect, useRef } from "react";

import { round } from "@shared/utils";

export const useImageMaskRef = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const resize = () => {
      if (ref.current) {
        const { height, width } = ref.current.getBoundingClientRect();
        const maskSize = round(((width - height) / 2 / width) * 100, 4);
        ref.current.style.setProperty("--mask-size", `${maskSize}%`);
      }
    };

    resize();
    window.addEventListener("resize", resize);

    return () => window.removeEventListener("resize", resize);
  }, []);

  return ref;
};
